import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getReservePolValueConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserve_pol_stats', timeframe)) as IPOLStats[]
	const pools = ['AVAX.AVAX', 'BCH.BCH', 'BSC.BNB', 'BTC.BTC', 'DOGE.DOGE', 'ETH.USDT-0XDAC17F958D2EE523A2206206994597C13D831EC7', 'LTC.LTC']
	const assetData: IPOLStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []

	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	const series1 = assetData[3].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})
	const series2 = assetData[3].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_RUNE }
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: IPOLStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.CURRENT_VALUE_RUNE }
			})
		)
	})
	config.push({
		data: series1,
		strokeWidth: 2,
		name: `Total Value $`,
		type: 'line',
		seriesGroup: '[usd]',
		color: `${color}`,
		unitSymbol: '$'
	})
	config.push({
		data: series2,
		strokeWidth: 2,
		name: `Total Value ᚱ`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${colors[0]}`,
		unitSymbol: 'ᚱ'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[rune]',
			color: colors[i + 1],
			unitSymbol: 'ᚱ'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const ReservePolValue = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getReservePolValueConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Current Value of Reserve POL Deployments"
			chartDesc={`Current value of Reserve POL deployments stacked by recipient pool in RUNE.\n Tracking address: thor1dheycdevq39qlkxs2a6wuuzyn4aqxhve4qxtxt`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default ReservePolValue
